import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './auth';
import { Layout } from './components/Layout';
import { Loading, Pending } from './components/ui';
import { LoginPage, ChangePasswordPage, ResetPasswordPage } from './pages/Auth';
import { MeuAmbientePage } from './pages/MeuAmbiente';
import { VisaoGeralPage } from './pages/VisaoGeral';
import { ProjectsPage, ProjectDetailPage, ProjectFormPage } from './pages/Projetos';
import { KanbanPage, PhasesPage } from './pages/Kanban';
import { ContractFormPage } from './pages/Contratos';
import { CadastrosPage, ClientsPage, ClientDetailPage, ClientFormPage, ConsultantsPage, LookupPage } from './pages/Cadastros';
import { ConfiguracoesPage } from './pages/Configuracoes';
import { AgendaPage, AppointmentDetailPage, AppointmentFormPage } from './pages/Agenda';
import { ExecutionEditPage, ExecutionsPage, QuickDraftPage } from './pages/Execucoes';
import { HourBankPage, HourBanksPage } from './pages/BancosHoras';
import { BillingPage } from './pages/Faturamento';
import { ContractDetailPage } from './pages/ContratoDetalhe';
import { ReportsPage, TemplatesPage } from './pages/Relatorios';
import { AlertsPage } from './pages/Alertas';
import { MessageComposerPage } from './pages/Mensagens';
import { NovidadesPage } from './pages/Novidades';

function Future({ title, stage }: { title: string; stage: string }) {
  return (
    <>
      <div className="page-head">
        <h1>{title}</h1>
      </div>
      <Pending title={title} stage={stage} />
    </>
  );
}

export function App() {
  const { user, loading } = useAuth();
  if (loading) return <Loading />;

  if (!user) {
    return (
      <Routes>
        <Route path="/redefinir-senha" element={<ResetPasswordPage />} />
        <Route path="*" element={<LoginPage />} />
      </Routes>
    );
  }
  if (user.mustChangePassword) return <ChangePasswordPage forced />;

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<MeuAmbientePage />} />
        <Route path="visao-geral" element={<VisaoGeralPage />} />
        <Route path="projetos" element={<ProjectsPage />} />
        <Route path="projetos/kanban" element={<KanbanPage />} />
        <Route path="projetos/novo" element={<ProjectFormPage />} />
        <Route path="projetos/:id" element={<ProjectDetailPage />} />
        <Route path="projetos/:id/editar" element={<ProjectFormPage />} />
        <Route path="projetos/:projectId/contratos/novo" element={<ContractFormPage />} />
        <Route path="contratos/:id/editar" element={<ContractFormPage />} />
        <Route path="cadastros" element={<CadastrosPage />} />
        <Route path="cadastros/clientes" element={<ClientsPage />} />
        <Route path="cadastros/clientes/novo" element={<ClientFormPage />} />
        <Route path="cadastros/clientes/:id" element={<ClientDetailPage />} />
        <Route path="cadastros/clientes/:id/editar" element={<ClientFormPage />} />
        <Route path="cadastros/consultores" element={<ConsultantsPage />} />
        <Route path="cadastros/fases" element={<PhasesPage />} />
        <Route path="cadastros/categorias" element={<LookupPage resource="categories" title="Categorias" />} />
        <Route path="cadastros/areas" element={<LookupPage resource="areas" title="Módulos/áreas" />} />
        <Route path="cadastros/tipos-compromisso" element={<LookupPage resource="appointment-types" title="Tipos de compromisso" />} />
        <Route path="configuracoes" element={<ConfiguracoesPage />} />
        <Route path="minha-senha" element={<ChangePasswordPage />} />
        <Route path="agenda" element={<AgendaPage />} />
        <Route path="agenda/novo" element={<AppointmentFormPage />} />
        <Route path="agenda/:id" element={<AppointmentDetailPage />} />
        <Route path="agenda/:id/editar" element={<AppointmentFormPage />} />
        <Route path="execucoes" element={<ExecutionsPage />} />
        <Route path="execucoes/nova" element={<QuickDraftPage />} />
        <Route path="execucoes/rascunho/:clientDraftId" element={<QuickDraftPage />} />
        <Route path="execucoes/:id" element={<ExecutionEditPage />} />
        <Route path="bancos-de-horas" element={<HourBanksPage />} />
        <Route path="bancos-de-horas/:contractId" element={<HourBankPage />} />
        <Route path="faturamento" element={<BillingPage />} />
        <Route path="contratos/:id" element={<ContractDetailPage />} />
        <Route path="relatorios" element={<ReportsPage />} />
        <Route path="alertas" element={<AlertsPage />} />
        <Route path="novidades" element={<NovidadesPage />} />
        <Route path="mensagens/:id" element={<MessageComposerPage />} />
        <Route path="cadastros/modelos-mensagem" element={<TemplatesPage />} />
        <Route path="redefinir-senha" element={<Navigate to="/" replace />} />
        <Route path="*" element={<Future title="Página não encontrada" stage="—" />} />
      </Route>
    </Routes>
  );
}
